import React from 'react';
import useTheme from '../../hooks/useTheme';
import Notification from '../Notification';
import './AuthLayout.css';

const AuthLayout = ({ children }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className={`auth-layout theme-${theme}`}>
      <button 
        className="auth-theme-toggle"
        onClick={toggleTheme}
        title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      >
        <span className="auth-theme-toggle-icon">
          {theme === 'dark' ? '☀️' : '🌙'}
        </span>
      </button>
      
      <div className="auth-branding">
        <div className="auth-logo">
          <svg width="40" height="40" viewBox="0 0 100 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" fill="white"/>
            <path 
              d="M38 20C38 29.9411 29.9411 38 20 38C10.0589 38 2 29.9411 2 20C2 10.0589 10.0589 2 20 2C29.9411 2 38 10.0589 38 20Z" 
              fill={theme === 'dark' ? '#8A2BE2' : '#008080'} 
            />
          </svg>
          <span className="auth-logo-text">WDTP</span>
        </div>
        <h1>Trading Platform</h1>
        <p>The world's first platform for digitalized intellectual property trading and investment</p>
      </div>
      
      <div className="auth-content">
        {children}
      </div>
      
      {/* Always show notifications */}
      <Notification />
    </div>
  );
};

export default AuthLayout; 